// extracted by css-extract-rspack-plugin
export default {"root":"root-F5EaB2","idle":"idle-kjgFtd","muted":"muted-D5bPHJ","active":"active-YkUWBe","ready":"ready-QUszYs","warning":"warning-XPeWPf","done":"done-tDBFEN"};